// extracted by mini-css-extract-plugin
export var option = "_5b-1";
export var optionActive = "_5b-2";
export var pill = "_5b-0";